import { DOMAIN } from "@/constants/env"

export const ADD_10_MINUTES = 600000
export const GLOBAL_CONFIGURATION_ENDPOINT = `${DOMAIN}/api/globalconfig`
export const STORE_DETAILS_API_ENDPOINT = `${DOMAIN}/api/storedetails`
export const DEFAULT_STORE_DETAILS_API_PATH =
  "/bin/kohler/services/storedetails?path="
export const GET_GUEST_TOKEN_ENDPOINT = `${DOMAIN}/api/token`
